import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton as HeroSkeleton } from '@heroui/react';
export const Skeleton = (props) => {
    return _jsx(HeroSkeleton, { ...props });
};
export default Skeleton;
//# sourceMappingURL=Skeleton.js.map